import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
// import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import FAQS from "../../../MyComponents/FooterPages/newfaq"
import heroContent from "../HeroContent-GDesign";
import leftimgs from "../../../assets/1 (59).png";
import rightimgs from "../../../assets/1 (10).png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import FunActivities from "../../../MyComponents/FunActivities";
import LearningStyle from "../../../MyComponents/LearningStyle"
import VideoSection from "../../../MyComponents/VideoSection";
import Testimonials from "../../../MyComponents/Testimonials";
import HeadSection from "../../HeadSection.js";
import pencilIcon from "../../../assets/pencil.png";
 const beginnerModules = [
    {
      title: "Module 1",
      activities: "09",
      classes: "08",
      description:" UI/UX Design- Younger students will learn UI/UX basics, create shapes, templates, and text, design social media posts, and use Whiteboards in Canva..",
    },
    {
      title: "Module 2",
      activities: "09",
      classes: "07",
      description:" UI/UX Design Advanced- Students learn to design websites, apps, logos, brochures, business cards, and book covers using Canva.",
    }
    
];    

  const benefitsData = [
      {
        title: "Design Basics",
        description: "Core graphic design concepts.",
        icon: "Polymath-images/canva-benefit-img1.png",
      },
      {
        title: "Elements & Principles",
        description: "Balance, contrast, alignment.",
        icon: "Polymath-images/canva-benefit-img9.png",
      },
      {
        title: "CorelDRAW Basics",
        description: "Navigate the interface and essential tools.",
        icon: "Polymath-images/canva-benefit-img3.png",
      },
      {
        title: "CorelDRAW Advanced",
        description: "Work with layers, vectors, and page layouts.",
        icon: "Polymath-images/canva-benefit-img1.png",
      },
      {
        title: "Color Tools",
        description: "Apply color theory and manage palettes efficiently",
        icon: "Polymath-images/canva-benefit-img5.png",
      },
      {
        title: "3D Tables",
        description: "Design detailed tables for print and digital",
        icon: "Polymath-images/Group 1686552393.png",
      },
      {
        title: "Object & Effects",
        description: "Add shadows, transparency, and special effects.",
        icon: "Polymath-images/Group 1686552385.png",
      },
      {
        title: "Logo Design",
        description: "Craft unique, scalable brand identities.",
        icon: "Polymath-images/Group 1686552379.png",
      },
      {
        title: "Certificates & Flex",
        description: "Build impactful, print-ready documents.",
        icon: "Polymath-images/canva-benefit-img9.png",
      },
    ];
    const activitiesData = [
        {
          title: "Business Card",
          image: "Polymath-images/canvaFun-img1.png",
        },
        {
          title: "Flyers",
          image: "Polymath-images/canvaFun-img2.png",
        },
        {
          title: "Logos",
          image: "Polymath-images/canvaFun-img3.png",
        },
        {
          title: "Book Covers",
          image: "Polymath-images/canvaFun-img4.png",
        },
        {
          title: "Brochures",
          image: "Polymath-images/canvaFun-img5.jpg",
        },
      ];
     const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how kids can turn their creativity into stunning designs! In this video, we’ll introduce fun tools, basic design tips, and exciting projects like logos, flyers, and digital art. Whether you're just starting out or love being creative, this is the perfect place to begin your design journey.",

      
    videoSrc: "https://www.youtube.com/embed/p4pilMiPITE",
  };
const Canva = () => {
  const Canvapage = heroContent.canvasection;
  return (
    <>
       {/* <GuestNav/> */}
     <HeadSection
      leftImg={"Polymath-images/1 (59).png"}
      rightImg={"Polymath-images/1 (10).png"}
      titlePart1="Canva Designing"
      titlePart2="Course"
      description="This fun and engaging course introduces young students to graphic design and UI/UX using the easy-to-use Canva platform. Kids will learn to create stories, posters, slides, and more while developing creativity, design thinking, and real-world skills in branding and problem-solving."
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={"Polymath-images/pencil.png"}
      button2Icon={"Polymath-images/pencil.png"}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
       <CourseTimeline
        title="Course Structure and Syllabus"
        modules={beginnerModules}
      />
       <Benefits
        title="How Students Can Benefit From Abacus"
        benefitsData={benefitsData}
      />
       <FunActivities
              mainTitle="Learn Corel Draw"
              subTitle="With 40+ Fun Activities"
              activities={activitiesData}
            />
        <LearningStyle/>
         <VideoSection
        title={videoData.title}
        description={videoData.description}
        videoSrc={videoData.videoSrc}
      />
      <Testimonials/>
      <FAQS/>
       <Footer/>
    </>
  )
}
export default Canva